import {FacebookFilled, InstagramFilled, MailOutlined, PhoneOutlined, WhatsAppOutlined} from '@ant-design/icons';
import {Divider, Image} from 'antd';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const FooterScreen = ({data}) => {
  return (
    <div
      id={'footer'}
      className={'w-full bg-primary-950 text-black flex flex-col justify-center shadow-[0_-4px_12px_rgba(0,0,0,0.08)] z-10 items-center px-4 lg:px-20 py-6 mt-auto'}
    >
      <div className={'w-full max-w-7xl'}>
        <div className={'grid grid-cols-1 lg:grid-cols-4 lg:gap-8 gap-2 text-base w-full'}>
          {/* Logo */}
          <div className={'flex flex-col items-center lg:items-start'}>
            <div className={'w-[120px] lg:w-[100px]'}>
              <Link to={'/'}>
                <Image src={data.image} alt={'logo'} className={'image-fill'} preview={false} />
              </Link>
            </div>
          </div>

          {/* Contact us */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold text-secondary-300'}>Contact Us</p>
            <div className={'flex items-center gap-2 mb-2'}>
              <PhoneOutlined rotate={90} className={'text-blue-700 text-lg'} />
              <span>{data.phone_no}</span>
            </div>
            <div className={'flex items-center gap-2'}>
              <MailOutlined className={'text-red-700 text-lg'} />
              <span>{data.email}</span>
            </div>
          </div>

          {/* Location */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold text-secondary-300'}>Location</p>
            <p className={'text-center lg:text-left'}>{data.location}</p>
          </div>

          {/* Social media links */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold text-secondary-300'}>Follow Us</p>
            <div className={'flex gap-4'}>
              <Link to={data.facebookLink} target={'_blank'}>
                <FacebookFilled className={'text-[#3e2c2c] text-2xl'} />
              </Link>
              <Link to={data.instagramLink} target={'_blank'}>
                <InstagramFilled className={'text-[#3e2c2c] text-2xl'} />
              </Link>
              <Link to={data.whatsappLink} target={'_blank'}>
                <WhatsAppOutlined className={'text-[#3e2c2c] text-2xl'} />
              </Link>
            </div>
          </div>
        </div>

        {/* Divider */}
        <Divider className={'my-6'} />

        {/* Bottom row */}
        <div className={'flex lg:flex-row flex-col justify-between items-center gap-2 text-sm text-center'}>
          <div>© {new Date().getFullYear()} All rights reserved - Sobin Interiors</div>
          <div>Powered By - Ascensify  </div>
        </div>
      </div>
    </div>
  );
};

FooterScreen.propTypes = {
  data: PropTypes.shape,
};

export default FooterScreen;
